module.exports = __webpack_public_path__ + "img/qrcode_ebsorg.a91bf495.png";